import React, {useEffect, useState} from "react";
import "./profile.scss";
import "moment/locale/es";
import {ProfileSteps} from "./profileSteps";
import {genderIdentityService} from "../../services/genderIdentity.service";
import {useDispatch, useSelector} from "react-redux";
import {ProfileUser} from "./profileUser";
import {GetUserProfile} from "../../utils/ProfileFunctions";
import {setUserProfile} from "../../store/actions";

export const Profile = () => {
    const [genderIdentityCatalog, setGenderIdentityCatalog] = useState([]);
    const profileInfo = useSelector((state) => state.userProfile);
    const dispatch = useDispatch();

    const handleLoadCatalogIdentities = () => {
        genderIdentityService
            .getAll(process.env.REACT_APP_COMPANY)
            .then((genderData) => setGenderIdentityCatalog(genderData));
    };

    const handleUpdateProfile = async () => {
        const dataProfile = await GetUserProfile();
        if(dataProfile) dispatch(setUserProfile(dataProfile));
    }

    useEffect(() => {
        handleLoadCatalogIdentities();
    }, []);

    return (
        <section className="profile">
            <BackgroundPride status={profileInfo.genderIdentityFlag} />
            {
              (profileInfo?.genderIdentityId === null || profileInfo.urlProfileImage === process.env.REACT_APP_AVATAR_URL || profileInfo.pronoun === null) ?
                  <ProfileSteps
                      genderIdentityCatalog={genderIdentityCatalog}
                      handleUpdateProfile={handleUpdateProfile}
                      profileInfo={profileInfo}
                  />
                :
                  <ProfileUser
                      handleUpdateProfile={handleUpdateProfile}
                      profileInfo={profileInfo}
                      genderIdentityCatalog={genderIdentityCatalog}
                  />
            }
        </section>
    );
}

export const BackgroundPride = ({status = "null"}) => {
    return <div className={`profile__background-pride ${status}-solid`}></div>
}